import { storage } from "../config/config";
import slugify from "slugify";
import toast from "react-hot-toast";
import { ref, uploadBytesResumable, getDownloadURL, uploadString as uploadStringFirebase } from "firebase/storage";

export const uploadFile = async (file, checkProgress, fileUrl) => {
  if (file) {
    if (file.size / 100000000 > 1) {
      toast.error("File yang dimasukan Melebihi batas 100MB");
      return;
    }
    const newFileName = `${new Date().getTime()}-${slugify(file?.name)}`;
    const fileRef = ref(storage, newFileName);

    const uploadTask = uploadBytesResumable(fileRef, file);

    if (checkProgress && fileUrl) {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          let progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          if (checkProgress) {
            checkProgress(progress.toFixed(0));
          }
        },
        (error) => {
          toast.error("Terjadi kesalahan saat mengunggah file.");
          console.error(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          if (fileUrl) {
            fileUrl(downloadURL);
          }
        }
      );
    } else {
      const snapshot = await uploadTask;
      const url = await getDownloadURL(snapshot.ref);
      return url;
    }
  }
};

export const uploadString = async (name, string) => {
  if (name && string) {
    const newFileName = `${new Date().getTime()}-${slugify(name)}`;
    const fileRef = ref(storage, newFileName);

    await uploadStringFirebase(fileRef, string, "data_url");
    const url = await getDownloadURL(fileRef);

    return url;
  }
};
